import { apiSlice } from "../apiSlice";

export interface ReturnItem {
    displayName: string;
    itemType: string;
    menuItemId: string;
    portionSize: string;
    unitPrice: number;
    quantity: number;
}

export interface ReturnRequestsDetails {
    id: string;
    restaurantId: string;
    restaurantName: string;
    status: string;
    cart: {
        cartId: string;
        displayName: string;
        cartPersonId: string;
        userId: string;
    }
    items: ReturnItem[];
    createdAt: {
        _seconds: number;
        _nanoseconds: number;
    }
}

export interface ReturnRequestsResponse {
    returnRequestsList: ReturnRequestsDetails[];
}

export interface ReturnRequestsStatusUpdate {
    requestId: string;
    status: string;
}

export interface ReturnRequestsStatusUpdateResponse {
    updatedStatus: string;
    requestId: string;
}

const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_DEV || process.env.REACT_APP_API_BASE_DOMAIN_PROD || '';

export const returnRequestService = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getReturnRequests: builder.query({
            query: ({ restaurantId }) => ({
                url: `https://adminhttps-getcartreturnrequestbyrestaurantid${API_BASE_DOMAIN}?restaurantId=${restaurantId}`,
                method: 'GET',
                responseHandler: (response) => response.json(),
            }),
        }),
        getReturnRequestById: builder.query<ReturnRequestsDetails, string>({
            query: (requestId) => ({
                url: `https://adminhttps-getcartreturnrequestbyid${API_BASE_DOMAIN}?requestId=${requestId}`,
                method: 'GET',
                responseHandler: (response) => response.json(),
            }),
        }),
        // returnRequestStatusUpdate: builder.mutation<any, ReturnRequestsStatusUpdate>({
        //     query: (data) => ({
        //         url: `https://adminhttps-updatereturnrequeststatus${API_BASE_DOMAIN}`,
        //         method: "POST",
        //         body: data,
        //         responseHandler: (response) => response.json(),
        //     }),
        // }),
        returnRequestStatusUpdate: builder.mutation<ReturnRequestsStatusUpdateResponse, ReturnRequestsStatusUpdate>({
            query: (data) => ({
                url: `https://adminhttps-updatereturnrequeststatus${API_BASE_DOMAIN}`, // Fixed URL formatting
                method: "POST",
                body: data,
                // responseHandler: (response) => response.json(),
                responseHandler: async (response) => {
                    const text = await response.text();

                    if (!text && response.ok) {
                        return { response };
                    }

                    try {
                        return text ? JSON.parse(text) : { response };
                    } catch (e) {
                        if (response.ok) {
                            return { response };
                        }
                        throw e;
                    }
                },
                validateStatus: (response) => {
                    return response.status === 200 || response.status === 204;
                }
            }),
            // transformResponse: (response:any) => {
            //     return {
            //         status: response || "Updated" 
            //     };
            // }
        }),
    }),
});

export const {
    useGetReturnRequestsQuery,
    useLazyGetReturnRequestsQuery,
    useGetReturnRequestByIdQuery,
    useLazyGetReturnRequestByIdQuery,
    useReturnRequestStatusUpdateMutation
} = returnRequestService;